import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { IoMdClose } from "react-icons/io";
import PageRender from "./PageRender";
import Home from "./pages";
import Sidebar from "./components/sidebar";
import Login from "./screens/login";
import useAuthStore from "./data/stores/authStore";
import useErrorStore from "./data/stores/errorStore";
import { ModalContainer } from "./components/partials/modalbackground";

const Routers = () => {
	const location = useLocation(),
		{ error, clearErrors } = useErrorStore(),
		{ isAuth } = useAuthStore();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);
	return (
		<>
			{/* <Header /> */}
			<Toaster position="top-right" />
			<Sidebar>
				<Routes>
					<Route path="/" element={isAuth ? <Home /> : <Login />} />
					<Route path="/:page" element={<PageRender />} />
					<Route path="/:page/:id" element={<PageRender />} />

					<Route path="/:page/:id/:step" element={<PageRender />} />
				</Routes>
			</Sidebar>
			{error?.length > 0 && (
				<ModalContainer>
					<div className="bg-white modal-shadow w-[400px] rounded-xl p-6">
						<div className="flex justify-between">
							<div>
								<h3 className="text-xl font-bold text-black">Error</h3>
							</div>
							<IoMdClose
								size={20}
								onClick={() => clearErrors()}
								className="cursor-pointer"
								color="#A6A6A6"
							/>
						</div>

						<div className="">
							{error?.map((item: any, i: number) => (
								<p key={i} className="fw-bold inter w-100">
									<span className="fontInherit me-2">
										{error?.length !== 1 && <>{i + 1}.</>}
									</span>{" "}
									{item?.message || item || null}{" "}
									{item?.path?.includes("[") ? (
										<>
											(
											{Number(
												item?.path
													?.substring(item?.path.indexOf("[") + 1)
													?.split("]")?.[0]
											) + 1}
											)
										</>
									) : null}
								</p>
							))}
						</div>

						<button
							onClick={() => clearErrors()}
							className="mt-8 bg-[#3787FF] text-[#F2FBFF] h-12 w-full rounded-lg text-base font-medium">
							Close
						</button>
					</div>
				</ModalContainer>
			)}
		</>
	);
};

export default Routers;
